import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/angleRightBold.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
